<template>
  <el-card class="box-card1">
    <h1>{{ title }}</h1>
    <h4 v-html="content"></h4>
  </el-card>
</template>

<script>
export default {
  name: "BaseBox",
  props: ["article"],
  data() {
    return {
      title: "",
      content: "",
      isRender: false
    };
  },
  watch: {
    article: {
      handler(newArticle) {
        this.title = newArticle.title;
        this.content = newArticle.content;
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {}
};
</script>

<style>
h4 {
  font-size: 16px;
  font-weight: 500;
}
.box-card1 {
  min-height: 800px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/BaseBox.vue